import type { TourConfig } from '../types'

import { dashboardTour } from './dashboard'
import { welcomeTour } from './welcome'

export const tourRegistry: Record<string, TourConfig> = {
  welcome: welcomeTour,
  dashboard: dashboardTour,
}

export const getTour = (id: string): TourConfig | null => {
  return tourRegistry[id] || null
}

export const getAllTours = (): TourConfig[] => {
  return Object.values(tourRegistry)
}
